import type { ComboBoxProps } from "@dealer-center/core-components";
import { ComboBox } from "@dealer-center/core-components";
import { allMakesList } from "./allMakesList";

type AllMakesComboBoxProps = Omit<ComboBoxProps, "options">;
const options = allMakesList.map(make => ({
  label: make,
  value: make
}));
export const AllMakesComboBox = (props: AllMakesComboBoxProps) => {
  return <ComboBox {...props} options={options} />;
};
